import { useAppSelector } from 'store';
import { useDispatch } from 'react-redux';
import { tasksInformationActions } from 'entities/task/model/slice/tasksInformation';

export const useShowCompleted = () => {
    const dispatch = useDispatch();
    const { isShowCompleted } = useAppSelector((state) => state.tasksInformationReducer);

    const toggle = () => {
        dispatch(tasksInformationActions.changeShowCompleted(!isShowCompleted));
    };

    return { isShowCompleted, toggle };
};
